import {
    LandingpageH1,
    LandingpageContainer,
    LandingpageSubtitle,
    LandingpageTextContainer,
    LandingpageTitle,
} from '../assets/styles/landingpageStyles';
import { TheSun } from '../lib/components/TheSun';

export function Landingpage() {
    return (
        <LandingpageContainer>
            <TheSun isInText={true} onLandingpage={true} />
            <LandingpageTextContainer>
                <LandingpageTitle>
                    <LandingpageH1>WATCH OUT</LandingpageH1>
                </LandingpageTitle>
                <LandingpageSubtitle>FÜR MEHR SONNENSCHUTZ AN ORTEN DER FREIZEIT</LandingpageSubtitle>
            </LandingpageTextContainer>
        </LandingpageContainer>
    );
}